import { Brick } from './brick';

export const bricks = new Array<Brick>();
